import type { NonIndexRouteObject } from "react-router-dom";
import { lazy, ReactNode } from "react";
import { UnorderedListOutlined, FileSyncOutlined } from "@ant-design/icons";
import { TTeacherType } from "@/store/globle/types";
import { LazyImportComponent } from "@/components/lazy-import-component";
import RouterD from "@/components/RouterD";
import SchoolDiagnoseReport from "@/pages/SchoolDiagnoseReport";

interface MenuChild {
  menu_name?: string;
  class_type?: number;
  plid?: string;
  sort?: number;
  type?: number;
  url?: string;
  lid?: string;
  menu_info?: any;
}

interface Menu extends MenuChild {
  child_menu?: MenuChild[];
}
interface MenuProps {
  teacher_id?: number;
  detail_menu?: Menu[];
}

//路由项配置信息
export interface ICustomRouterConfig extends NonIndexRouteObject {
  show?: boolean; // 是否显示在侧边栏菜单
  icon?: ReactNode;
  // icon?: React.Component;
  label?: string;
  // 不同老师类型访问权限不同，向数组中添加老师类型对应老师可以访问路由（管理员教师类型默认无需添加，可以访问所有页面）
  role?: TTeacherType[]; //1.0优化前使用该字段
  children?: ICustomRouterConfig[];
}

//左侧路由lid 与后端一致
enum RoutesName {
  BASIC_DATA = "29d445cf-0bce-69ed-9776-09bb2dda5614",
  DIAGNOSIS_CONTACT = "d68196c3-e515-22a2-5820-e77631f6676e",
  TEST_LIST = "ad5da04d-74ed-de1d-dbb1-df26405ceafb",
  DIAGNOSIS_LIST = "45465536-237c-8b41-b0d7-5cbfc5b8fb31",
  PAPER_LIST = "119d1ba2-3e40-6f58-342e-964dda4c5acc",
  LEARNING_FEEDBACK = "568adb41-cff0-7005-35d8-396085fefb34",
}

// export const routes: ICustomRouterConfig[] = [
//   {
//     label: "路由守卫",
//     element: <RouterD></RouterD>,
//     children: [
//       {
//         label: "学业诊断",
//         path: "/schoolDiagnose",
//         element: <SchoolDiagnoseReport></SchoolDiagnoseReport>,
//       },
//     ],
//   },
// ];
export const routes: ICustomRouterConfig[] = [
  {
    label: "路由守卫",
    element: <RouterD></RouterD>,
    children: [
      {
        label: "学业诊断",
        path: "/schoolDiagnose",
        element: <SchoolDiagnoseReport></SchoolDiagnoseReport>,
      },
    ],
  },
];

//不在左侧菜单栏且有权限的页面
const notLeftMenuPage: ICustomRouterConfig[] = [
  {
    path: "/test/paperList/knowledgeTree",
    label: "知识树管理",
    element: (
      <LazyImportComponent
        lazyComponent={lazy(() => import("@/pages/KnowledgeTree"))}
      />
    ),
  },
  {
    path: "/test/paperList/createTestPaper",
    label: "创建新试卷",
    element: (
      <LazyImportComponent
        lazyComponent={lazy(() => import("@/pages/CreateTestPaper"))}
      />
    ),
  },
  {
    path: "/landingPage",
    label: "",
    element: (
      <LazyImportComponent
        lazyComponent={lazy(() => import("@/pages/LandingPage"))}
      />
    ),
  },
];
//不在左侧菜单栏且无权限的页面
const noAuthorityRoutes: ICustomRouterConfig[] = [
  {
    path: "/noAuthority",
    label: "",
    element: (
      <LazyImportComponent
        lazyComponent={lazy(() => import("@/pages/NoAuthority"))}
      />
    ),
  },
];
//左侧菜单对应的页面
const initRoutesPath = () => {
  const routesPath = {};
  routesPath[RoutesName.BASIC_DATA] = {
    icon: <FileSyncOutlined />,
  };
  routesPath[RoutesName.DIAGNOSIS_CONTACT] = {
    element: (
      <LazyImportComponent
        lazyComponent={lazy(() => import("@/pages/DiagnosisCorrelation"))}
      />
    ),
  };
  routesPath[RoutesName.TEST_LIST] = {
    icon: <UnorderedListOutlined />,
  };
  routesPath[RoutesName.DIAGNOSIS_LIST] = {
    element: (
      <LazyImportComponent
        lazyComponent={lazy(() => import("@/pages/DiagnosisList"))}
      />
    ),
  };
  routesPath[RoutesName.PAPER_LIST] = {
    element: (
      <LazyImportComponent
        lazyComponent={lazy(() => import("@/pages/PaperList"))}
      />
    ),
  };
  routesPath[RoutesName.LEARNING_FEEDBACK] = {
    element: (
      <LazyImportComponent
        lazyComponent={lazy(() => import("@/pages/SystemFeedBack"))}
      />
    ),
  };
  return routesPath;
};
//递归遍历menu
const getInitMenu = (menu, routesPath) => {
  const routes: ICustomRouterConfig[] = [];
  //通过后端返回的sort排序
  menu
    .sort((a, b) => a.sort - b.sort)
    .forEach((item: Menu, _) => {
      const route: ICustomRouterConfig = {};
      route.show = true; //后端返回的页面均是在左侧菜单显示的页面
      route.path = item.url;
      route.label = item.menu_name;
      if (routesPath[item.lid].icon) route.icon = routesPath[item.lid].icon;
      if (item.child_menu && item.child_menu.length > 0) {
        route.children = getInitMenu(item.child_menu, routesPath);
      } else {
        route.element = routesPath[item.lid].element;
      }
      routes.push(route);
    });
  return routes;
};

//初始化路由
const initRoutes = async (menu: MenuProps) => {
  routes[0].children = [];
  if (menu?.detail_menu?.length) {
    let routesPath = initRoutesPath();
    routes[0].children = getInitMenu(menu.detail_menu, routesPath);
    routes[0].children = routes[0].children.concat([...notLeftMenuPage]);
  } else {
    routes[0].children = noAuthorityRoutes;
  }
  return routes;
};

export default initRoutes;
